import TitleListsImport from '@pages/title-lists/TitleListsImport'
import TitleListsManual from '@pages/title-lists/TitleListsManual'
import { beforeRouteEnterAction } from '@router/router.utils'

export default [
  {
    path: '/title-lists/imports/:id/create',
    name: 'product-title-list-imports-create',
    component: TitleListsImport,
    meta: {
      requiresAuth: true,
      actions: ['products/getSingle', 'titleLists/getProductTitleListImportData'],
      hasSearchBar: true,
      pageTitle: 'Title Lists',
      pathToLocalization: 'title-lists.title'
    },
    beforeEnter: beforeRouteEnterAction
  },
  {
    path: '/title-lists/manual/:id/create',
    name: 'product-title-list-manual-create',
    component: TitleListsManual,
    meta: {
      requiresAuth: true,
      actions: ['products/getSingle', 'titleLists/getManualCreateData'],
      hasSearchBar: true,
      pageTitle: 'Title Lists',
      pathToLocalization: 'title-lists.title'
    },
    beforeEnter: beforeRouteEnterAction
  }
]
